// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import { CategoryTypeaheadCategoryFragmentDoc } from '../../typeahead/__generated-gql-types__/CategoryTypeahead.generated';
export type EventCategoryDropdownCategoryFragment = {
  __typename?: 'Category';
  id: string;
  slug: string;
  goal: Types.GoalName;
  name: string;
  subCategoryList?: Array<{
    __typename?: 'SubCategory';
    id: string;
    slug: string;
    v2Urn: string;
    name: string;
  }> | null;
};

export const EventCategoryDropdownCategoryFragmentDoc = gql`
  fragment EventCategoryDropdown_Category on Category {
    id
    ...CategoryTypeahead_Category
  }
  ${CategoryTypeaheadCategoryFragmentDoc}
`;
